<template>
    <div class="body">
        <span style="font-size:16px; font-weight: 600;">
            当前一共:
            <span style="color:red"> {{ list.length }} </span> 
            个题解
        </span>
        <!-- <div style="float: right; margin-right:50px">
            <el-button type="success" round>新增竞赛</el-button>
        </div> -->
        <table class="table table-striped table-hover">
            <thead>
                <tr style="font-size: 14px;">
                    <th scope="col-1">发布者昵称</th>
                    <th scope="col-2">标题</th>
                    <th scope="col-2">点赞数</th>
                    <th scope="col-4">发布日期</th>
                    <th scope="col-1">题目id</th>
                    <th scope="col-2">删除题解</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="t in showpage" :key="t.id">
                    <th class="col-1" style="font-size: 15px;">{{ t.name }}</th>
                    <th class="col-2" style="font-size: 15px;">{{ t.title }}</th>
                    <td class="col-2" style="font-size: 15px;">{{ t.goods }}</td>
                    <td class="col-4" style="font-size: 15px;">{{ t.createtime }}</td>
                    <!-- <td class="col-4" style="font-size: 15px;">{{ t.startTime }} - {{ t.closeTime }}</td> -->
                    <td class="col-1" style="font-size: 13px;">
                        {{ t.pbid }}
                    </td>
                    <td class="col-2" style="font-size: 13px;">
                        <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 13px;" @click="ClickMeToDelete(t)">删除</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- 分页设置 -->
        <div class="block">
            <!-- :page-size="100" 表示一页100条消息，上限1000条 所以说想自定义上限可以 ==> 想要的页数k  :page-size="(1000 + k - 1) / k"-->
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="1" 
            layout="prev, pager, next, jumper"
            :total="1000">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url'

    export default {
        name:'UpdateCompete',
        data() {
            return {


                /* 题库修改部分 */
                currentPage3: 1, // 分页
                showpage:[], // 题库数组
                /* 这里是修改题目信息的地方 */
                id: '',

                list:[],
            }
        },
        mounted() {
            this.readAllNotes()
        },
        methods: {
            ClickMeToDelete(item) {
                const vue = this
                const store = this.$store
                const route = this.$route
                const router = this.$router

                $.ajax({
                    url: 'https://app6132.acapp.acwing.com.cn/api/notes/delete/',
                    type: "post",
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: item.id,
                        userid: item.userid,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.readAllNotes()
                        }
                    }
                })
            },
            handleSizeChange(val) { // 没啥用
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) { // 实现分页
                console.log(`当前页: ${val}`);
                const Topic = this.list
                this.showpage.length = 0
                this.showpage = Topic.slice((val - 1) * 10, Math.min(val * 10, Topic.length))
            },
            readAllNotes() {
                const vue = this
                const store = this.$store
                
                $.ajax({
                    url: Url.rAllNotesUrl,
                    type: 'post',
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.list = JSON.parse(resp.list)
                            
                            const Topic = vue.list
                            vue.showpage.length = 0
                            vue.showpage = Topic.slice(0, Math.min(10, Topic.length))
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
.body {
    width: 1170px;
    min-height:165px;
    height: auto;
    margin:0 auto;
    background-color: white;
    padding: 20.8px;
    border-radius: 5px;
    box-sizing: border-box;
    border:2px solid lightgrey;
}
</style>